let devUrl = ''
const socketUrl = window.location.href.includes('localhost') ? devUrl || 'https://zjytest.glodon.com'
  : window.location.href.includes('39.96.15.61') ? devUrl || 'https://zjytest.glodon.com'
    : window.location.href.includes('zjytest') ? 'https://zjytest.glodon.com'
      : window.location.href.includes('zjy-dev') ? 'https://zjy-dev.glodon.com'
        : window.location.href.includes('zjy-pre') ? 'https://zjy-pre.glodon.com'
          : window.location.href.includes('zjy-gray-pre') ? 'https://zjy-pre.glodon.com'
            : window.location.href.includes('xmgl-gor') ? 'https://zjy-pre.glodon.com'
              : window.location.href.includes('xmgl') ? 'https://zjy.glodon.com'
                : 'https://zjy.glodon.com'

export default {
  baseUrl: {
    // development: 'http://ccpdev.glodon.com', // 开发环境
    // test: 'https://ccpdev.glodon.com', // 测试环境
    // pre: 'https://ccptest.glodon.com', // 预上线
    // pt: 'https://ccppre.glodon.com/pt', // 预上线
    // production: 'https://ccp.glodon.com' // 线上环境
  },
  WS: {
    base: { // websocket请求的baseURL
      development: process.env.VUE_APP_SOCKET_URL || `${socketUrl}/websocket`,
      production: process.env.VUE_APP_SOCKET_URL || `${socketUrl}/websocket`
      // 预上线：ws://zjy-pre.glodon.com/websocket  正式：ws://zjy.glodon.com/websocket
    },
    subscribe: { // websocket 订阅相关
      share: '/topic/web/' // 分享消息
    },
    sendMessage: { // 向服务端发送消息先关
      share: '/topic/web/' // 分享消息
    }
  }
}
